import type { GetProjectFilesResponseBody } from "@imagine/ai-service/shared-types/route-types";
import { aiServiceFetch } from "./ai-service-client";
import { HttpError } from "./http-error";

export async function fetchProjectFilesFromSandbox({
  projectId,
  token,
}: {
  projectId: string;
  token: string;
}): Promise<GetProjectFilesResponseBody> {
  const response = await aiServiceFetch(`/api/projects/${projectId}/files`);

  if (!response.ok) {
    throw await HttpError.fromResponse(response);
  }

  return response.json();
}
